module.exports = __webpack_public_path__ + "static/media/triviaChat-home.9de58ee8.png";